import { z } from 'zod'

export const paymentJustificationStatusFormValidationSchema = z.object({
  justification_file: z
    .array(
      z.object({
        id: z.string().optional(),
        file: z.instanceof(File).optional(),
        url: z.string(),
        name: z.string(),
      }),
    )
    .min(1, 'Selecione pelo menos um arquivo.')
    .max(3, 'Você só pode fazer upload de no máximo 3 documentos.')
    .refine(
      (files) =>
        files.every(({ file }) => !file || file.type === 'application/pdf'),
      'Apenas arquivos PDF são permitidos.',
    ),

  comment: z.string().min(1, 'O comentário é obrigatório.'),
  send_email: z.boolean().optional(),
  reference_date: z.string().optional(),
  description_status: z.string().optional(),
  payment_justification_id: z.string().optional(),
  installment_id: z.string().optional(),
})

export type PaymentJustificationStatusFormValues = z.infer<
  typeof paymentJustificationStatusFormValidationSchema
>

export const defaultPaymentJustificationValues: PaymentJustificationStatusFormValues =
  {
    comment: '',
    justification_file: [],
    send_email: false,
    description_status: '',
    payment_justification_id: '',
    reference_date: '',
    installment_id: '',
  }
